import React from "react";
import { QueryClientProvider } from "react-query";
import { StyleSheetManager } from "styled-components";
import { ColorProvider } from "@cinesys/ui/components";
import AppRouter from "./AppRouter";
import CustomerApiService from "./CustomerApiService";
import CustomerTheme from "./theme/CustomerTheme";

/**
 * Provider stack. `ColorProvider` is reused verbatim from `@cinesys/ui` (the
 * manager dark-navy + blue palette) as the DEFAULT theme for every customer
 * interface; `CustomerTheme` layers the (currently minimal) customer-stack
 * global style on top — see spec §4.2. `AppRouter` owns its own
 * `BrowserRouter` (basename="/"), unlike vault's `App.tsx`.
 *
 * No session gate here: the no-token redirect happens pre-mount in index.tsx,
 * and the expired-token case is handled reactively inside AppRouter.
 */
function App() {
  return (
    <StyleSheetManager shouldForwardProp={() => true}>
      <QueryClientProvider client={CustomerApiService.queryClient}>
        <ColorProvider>
          <CustomerTheme>
            <AppRouter />
            <div id="PortalTarget" />
          </CustomerTheme>
        </ColorProvider>
      </QueryClientProvider>
    </StyleSheetManager>
  );
}

export default App;
